<script lang="ts" setup></script>

<template>
  <details open class="group open:mb-0 -mb-6">
    <summary
      class="flex flex-row cursor-pointer select-none items-center min-w-0"
    >
      <div class="flex-1 min-w-0">
        <slot name="header" />
      </div>
      <v-icon
        icon="mdi-chevron-down"
        class="w-5 h-5 group-open:rotate-180 transition-transform shrink-0"
      />
    </summary>
    <div>
      <slot name="content" />
    </div>
  </details>
</template>
